import { Observable } from "rxjs";
import { RespInterface, RespListInterface } from "@common/ports/interfaces";
import { AddImgInterface, RecognitionFilterInterface } from "../interfaces";

export abstract class RecognitionAbstraction {
  abstract list(query: RecognitionFilterInterface): Observable<RespListInterface<string>>;
  abstract addImg(addImg: AddImgInterface): Observable<RespListInterface<string>>;
  abstract create(recognition: File, clientId: string, saveDb: boolean): Observable<RespInterface<{ name: string }>>;
  abstract deleteCache(data: any): Observable<RespInterface<string>>;
}
